import { extendTheme, type ThemeConfig } from '@chakra-ui/react'

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
}

export const theme = extendTheme({
  config,
  colors: {
    brand: {
      50: '#E6FFFA',
      100: '#B2F5EA',
      200: '#81E6D9',
      300: '#4FD1C5',
      400: '#38B2AC',
      500: '#009688',
      600: '#00766C',
      700: '#285E61',
      800: '#234E52',
      900: '#1D4044',
    },
  },
  fonts: {
    heading:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
    body: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
  },
  styles: {
    global: {
      body: {
        bg: '#F4F8F8',
        color: '#1A202C',
      },
      '*': {
        wordBreak: 'break-word',
      },
    },
  },
  components: {
    Container: {
      baseStyle: {
        maxW: 'container.xl',
      },
    },
    Card: {
      baseStyle: {
        container: {
          borderRadius: '16px',
          borderWidth: '1px',
          borderColor: 'gray.200',
          boxShadow: '0 8px 24px rgba(0, 70, 63, 0.08)',
          bg: 'white',
          overflow: 'hidden',
        },
      },
    },
    Button: {
      defaultProps: {
        colorScheme: 'brand',
      },
      baseStyle: {
        borderRadius: '12px',
        fontWeight: '600',
      },
    },
    Heading: {
      baseStyle: {
        letterSpacing: '-0.02em',
      },
    },
    Link: {
      baseStyle: {
        color: 'brand.700',
        _hover: {
          textDecoration: 'none',
          color: 'brand.600',
        },
      },
    },
  },
})
